import React from 'react'

function LocationMap() {
    return (
        <iframe title="location Map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3617.9954961298236!2d67.12616821447907!3d24.932223348518885!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb339226a950d7f%3A0xf6e59a255b3feae0!2sInformation%20technology%20Services!5e0!3m2!1sen!2s!4v1654585059245!5m2!1sen!2s" height={550} width={'100%'} allowFullScreen loading="lazy" />
    )
}

export default LocationMap;